import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import heroImage from "../assets/bg.png";
import logoImage from "../assets/logo.png";
import { AuthAPI } from "../services/api";
import { setToken } from "../services/authService";

export default function LoginPage() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const data = await AuthAPI.login(email, password);
      const role = data.user?.role;
      if (role && role !== "admin" && role !== "super_admin") {
        setError(t("login.noPermission"));
        return;
      }
      setToken(data.token);
      navigate("/admin", { replace: true });
    } catch (err) {
      setError(err.message || t("login.loginFailed"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="w-screen h-screen bg-[#1f1f1f]">
      <div className="w-full h-full grid grid-cols-1 lg:grid-cols-[1.05fr_1.2fr] bg-white overflow-hidden">
        {/* LEFT */}
        <div className="relative flex items-center justify-center">
          <div className="w-[min(520px,78%)] text-center px-3 py-10">
            <div className="flex justify-center mb-4">
              <div className="w-16 h-16 rounded-full border-2 border-gray-200 grid place-items-center bg-white overflow-hidden">
                <img src={logoImage} alt="logo" className="w-[54px] h-[54px] object-contain" />
              </div>
            </div>

            <div className="text-sm text-gray-600 mb-1">{t("login.staffLogin")}</div>
            <h1 className="text-[34px] leading-tight font-bold text-gray-900 mb-7">
              {t("login.systemTitle")}
            </h1>

            <form onSubmit={onSubmit} className="w-full grid gap-4 mt-2 text-left">
              <div>
                <label className="block text-[13px] font-semibold text-gray-900 mb-2">
                  {t("login.email")}
                </label>
                <input
                  className="w-full h-[46px] border border-gray-200 rounded-lg px-4 text-sm outline-none
                             focus:border-blue-500 focus:ring-4 focus:ring-blue-100"
                  placeholder={t("login.emailPlaceholder")}
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>

              <div>
                <label className="block text-[13px] font-semibold text-gray-900 mb-2">
                  {t("login.password")}
                </label>
                <input
                  className="w-full h-[46px] border border-gray-200 rounded-lg px-4 text-sm outline-none
                             focus:border-blue-500 focus:ring-4 focus:ring-blue-100"
                  placeholder={t("login.passwordPlaceholder")}
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
              </div>

              {error && (
                <div className="text-sm text-red-600 -mb-2">{error}</div>
              )}

              <button
                type="submit"
                disabled={loading}
                className="mt-2 w-full h-[50px] rounded-lg bg-[#1746d1] text-white font-bold hover:brightness-95 disabled:opacity-60"
              >
                {loading ? t("login.loggingIn") : t("login.loginButton")}
              </button>
            </form>

            <div className="absolute left-0 right-0 bottom-4 text-center text-xs text-gray-500 px-5">
              {t("login.copyright")}
            </div>
          </div>
        </div>

        {/* RIGHT */}
        <div className="relative bg-white hidden lg:block">
          <div
            className="w-full h-full bg-cover bg-left rounded-l-[140px]"
            style={{ backgroundImage: `url(${heroImage})` }}
          />
        </div>
      </div>
    </div>
  );
}
